/*
 * Kolon Seçici sıralaması (16.10.2026). Sürükleme, ekranda görünen (aramayla süzülmüş olabilen) listede yapılır;
 * sonuç tam listeye, sürüklenen kolon görünen listedeki yeni komşusunun yanına konarak taşınır.
 */

/** Sürüklenen kolonun, öteki satırların orta noktalarına göre listedeki yeni yeri. */
export const birakmaSirasi = (ortaNoktalar: number[], y: number) => ortaNoktalar.filter(orta => orta < y).length;

/** Görünen sırada `ad`ı `sira`ya koyar (sira, sürüklenen dışındaki satırlar arasındaki yerdir). */
export const yerlestir = (gorunen: string[], ad: string, sira: number) => {
    const kalan = gorunen.filter(x => x !== ad);
    kalan.splice(Math.max(0, Math.min(sira, kalan.length)), 0, ad);
    return kalan;
}

/**
 * Görünen listedeki yeni sırayı tam listeye uygular: sürüklenen kolon, görünen listede kendinden sonra gelen kolonun
 * önüne (yoksa kendinden önce gelenin arkasına) konur. Arama yokken görünen = tam liste olduğundan düz taşımadır.
 */
export const tamListeyeUygula = (tumu: string[], yeniGorunen: string[], ad: string) => {
    const i = yeniGorunen.indexOf(ad);

    if (i < 0 || !tumu.includes(ad))
        return tumu;

    const kalan = tumu.filter(x => x !== ad);
    const sonraki = yeniGorunen[i + 1];
    const onceki = yeniGorunen[i - 1];

    if (sonraki !== undefined && kalan.includes(sonraki))
        kalan.splice(kalan.indexOf(sonraki), 0, ad);
    else if (onceki !== undefined && kalan.includes(onceki))
        kalan.splice(kalan.indexOf(onceki) + 1, 0, ad);
    else
        kalan.splice(tumu.indexOf(ad), 0, ad);

    return kalan;
}

/** Fare kenara yaklaştıkça hızlanan kaydırma adımı (piksel/kare); bölge dışında 0. */
export const kenarKaydirma = (y: number, ust: number, alt: number, bolge = 48, enHizli = 18) => {
    if (y < ust + bolge)
        return -Math.ceil(enHizli * Math.min(1, (ust + bolge - y) / bolge));

    if (y > alt - bolge)
        return Math.ceil(enHizli * Math.min(1, (y - (alt - bolge)) / bolge));

    return 0;
}
